import { createRoot } from "react-dom/client";

import App from "./App";
import "./index.css";

const mswEnabled = import.meta.env.VITE_ENABLE_MSW === "true";

/**
 * This app used to have some service worker code, but it has since been removed.
 * Keeping this to remove existing service workers.
 * Remove after 2026-01-01
 */
function unregister() {
    if ("serviceWorker" in navigator) {
        navigator.serviceWorker.ready
            .then((registration) => {
                registration.unregister();
            })
            .catch((error) => {
                console.error(error.message);
            });
    }
}

async function bootstrap() {
    if (mswEnabled) {
        const { worker } = await import("./mocks/browser");
        await worker.start({ onUnhandledRequest: "bypass" });
    } else {
        unregister();
    }

    const container = document.getElementById("root");
    const root = createRoot(container!);
    root.render(<App />);
}

bootstrap();
